import { ReactElement } from 'react';

import LockOutlinedIcon from '@mui/icons-material/LockOutlined';
import { LoadingButton as Button } from '@mui/lab';

import { LoginButtonProps } from './types';

import { useSelector } from '../../common/hooks';
import LoginModal from '../LoginModal';

export default function LoginButton(props: LoginButtonProps): ReactElement {
  const user = useSelector((state) => state.user);

  const { children, open = false, startIcon, onClick, onSuccess, onSetModal, ...rest } = props;

  const handleOnClick = (): void => {
    if (user.data.loggedIn) {
      onClick({
        sessionId: user.data.sessionId,
        playerId: user.data.playerId,
        fullname: user.data.fullname,
        email: user.data.email
      });
    } else {
      onSetModal(true);
    }
  };

  return (
    <>
      <Button
        {...rest}
        startIcon={!user.data.loggedIn ? <LockOutlinedIcon /> : startIcon}
        onClick={() => handleOnClick()}>
        {user.data.loggedIn ? children : 'Login'}
      </Button>

      <LoginModal
        open={open}
        onClose={() => onSetModal(false)}
        onSuccess={(values) => (onSuccess ? onSuccess(values) : onClick(values))}
      />
    </>
  );
}
